/* eslint-disable react/no-unescaped-entities */
import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';

import {useAppDispatch} from 'store/hooks';
import {clickOpenMenu} from 'store/menuOpenSlice';
import {logoutUser} from 'store/userSlice';

const Topbar = () => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	const handleOpen = () => dispatch(clickOpenMenu());
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	const userName = localStorage.getItem('userName');

	const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

	useEffect(() => {
		const closeDropdown = (event: MouseEvent) => {
			if (
				event.target instanceof Element &&
				!event.target.closest('.dropdown-toggle')
			) {
				setIsDropdownOpen(false);
			}
		};

		if (isDropdownOpen) {
			document.addEventListener('click', closeDropdown);
		}

		return () => document.removeEventListener('click', closeDropdown);
	}, [isDropdownOpen]);

	const handleLogout = () => {
		dispatch(logoutUser());
		navigate('/');
	};

	return (
		<nav
			className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow"
			data-testid="logout-button">
			{/* <!-- Sidebar Toggle (Topbar) --> */}
			<button
				onClick={handleOpen}
				id="sidebarToggleTop"
				className="btn btn-link d-md-none rounded-circle mr-3">
				<i className="bi bi-list text-dark" />
			</button>

			{/* <!-- Topbar Search --> */}

			{/* <!-- Topbar Navbar --> */}
			<ul className="navbar-nav ml-auto">
				{/* <!-- Nav Item - User Information --> */}
				<li className="nav-item dropdown no-arrow">
					<button
						className="nav-link dropdown-toggle"
						id="userDropdown"
						onClick={toggleDropdown}>
						<span className="mr-2 d-none d-lg-inline text-gray-600 small">
							{userName}
						</span>
						<img className="img-profile rounded-circle" src="" alt="" />
					</button>
					{/* <!-- Dropdown - User Information --> */}
					<div
						className={`dropdown-menu${
							isDropdownOpen ? ' show' : ''
						} dropdown-menu-right shadow animated--grow-in`}
						aria-labelledby="userDropdown">
						<button
							className="dropdown-item"
							data-toggle="modal"
							data-target="#logoutModal"
							onClick={handleLogout}>
							<i className="bi bi-box-arrow-right mr-2 text-gray-400" /> Logout
						</button>
					</div>
				</li>
			</ul>
		</nav>
	);
};

export default Topbar;
